var map = {
	"./apple.png": 61,
	"./apples.png": 62,
	"./apricots.png": 63,
	"./artichokes.png": 64,
	"./arugula.png": 65,
	"./asparagus.png": 66,
	"./avocado.png": 67,
	"./beets.png": 68,
	"./bell-peppers.png": 69,
	"./blackberries.png": 70,
	"./blueberries.png": 71,
	"./broccoli.png": 72,
	"./broccolini.png": 73,
	"./brussels-sprouts.png": 74,
	"./butternut-squash.png": 75,
	"./carrots.png": 76,
	"./cauliflower.png": 77,
	"./celery-root.png": 78,
	"./chard.png": 79,
	"./cherries.png": 80,
	"./collard-greens.png": 81,
	"./corn.png": 82,
	"./cranberries.png": 83,
	"./cucumber.png": 84,
	"./eggplant.png": 85,
	"./fava-beans.png": 86,
	"./fennel.png": 87,
	"./figs.png": 88,
	"./kale.png": 89,
	"./kiwi-fruit.png": 90,
	"./kohlrabi.png": 91,
	"./leeks.png": 92,
	"./melon.png": 93,
	"./oranges.png": 94,
	"./parsnips.png": 95,
	"./passion-fruit.png": 96,
	"./peaches.png": 97,
	"./pears.png": 98,
	"./peas.png": 99,
	"./persimmon.png": 100,
	"./pineapple.png": 101,
	"./plums.png": 102,
	"./pomegranate.png": 103,
	"./potatoes.png": 104,
	"./pumpkin.png": 105,
	"./radishes.png": 106,
	"./raspberries.png": 107,
	"./rhubarb.png": 108,
	"./rutabega.png": 109,
	"./spinach.png": 110,
	"./strawberries.png": 111,
	"./sunchokes.png": 112,
	"./sweet-potatoes.png": 113,
	"./tomatoes.png": 114,
	"./turnips.png": 115,
	"./wild-mushrooms.png": 116,
	"./zucchini.png": 117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60;